import { Schedule } from './schedule';

export interface GetSchedulesResponse {
  schedules: Schedule[];
}
